// @flow
import React, {useCallback} from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { TableRow, TableRowColumn } from 'material-ui/Table';

const BlockListItem = (props) => {
	const { history, block } = props;
	console.log(block);

	const redirect = useCallback(() => history.push(`/blocks/${block.id}`), [history]);

	return (
		<TableRow
			onClick={redirect}
			style={{ border: 0 }}
		>
			<TableRowColumn className="table--cell table--cell-body">{block.title}</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body">{block.slug}</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body">{block.active ? 'Активный' : 'Неактивный'}</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body">{block.linkedArticles.length}</TableRowColumn>
		</TableRow>
	);
};

export default withRouter(createFragmentContainer(BlockListItem, {
	block: graphql`
		fragment BlockListItem_block on Block {
			id
			title
			slug
			active
			linkedArticles {
				id
			}
		}
	`,
}));



// WEBPACK FOOTER //
// src/components/blocks/BlockListItem.js